import { styled } from '@mui/material';

export const Header = styled('div')`
  padding: 24px;
  display: flex;
  gap: 12px;
`;

export const Body = styled('div')`
  padding: 24px;
  flex: 1 1 0;
  overflow: auto;
`;

export const DialogText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NoDataOverlay = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  flex-direction: column;
`;

export const SendMessageDialog = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
